import { render, staticRenderFns } from "./SecondFactorStep.vue?vue&type=template&id=6dc12f70&lang=pug"
import script from "./SecondFactorStep.vue?vue&type=script&lang=ts"
export * from "./SecondFactorStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports